import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

interface DownloadButtonsProps {
  downloads?: {
    dealIds?: string;
    addressIds?: string;
    errors?: string;
    summary?: string;
  };
}

/**
 * Renders download buttons for available result files.
 * Only shows buttons for URLs that are present (not undefined).
 */
const DownloadButtons: React.FC<DownloadButtonsProps> = ({ downloads }) => {
  if (!downloads) return null;

  const buttons = [
    { label: 'Deal IDs', url: downloads.dealIds },
    { label: 'Address IDs', url: downloads.addressIds },
    { label: 'Errors', url: downloads.errors },
    { label: 'Summary', url: downloads.summary },
  ].filter((btn) => btn.url);

  if (buttons.length === 0) return null;

  return (
    <Box data-testid="download-buttons" sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Download Reports
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {buttons.map((btn) => (
          <Button
            key={btn.label}
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            href={btn.url!}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`download-${btn.label
              .toLowerCase()
              .replace(/\s+/g, '-')}`}
          >
            {btn.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default DownloadButtons;
